import { useMemo } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import * as atoms from 'src/atoms/report-insight'
import * as userAtoms from 'src/atoms/user'

export const useDownloadLimit = (resource: 'reports' | 'csv' = 'reports') => {
  const isTrial = useRecoilValue(userAtoms.isTrial)
  const [downloadLimit, setDownloadLimit] = useRecoilState(
    resource === 'reports' ? atoms.reportDownloadLimit : atoms.csvDownloadLimit
  )

  const onDecrementDownloads = () => {
    if (!isTrial || downloadLimit === undefined || downloadLimit - 1 < 0) {
      return
    }
    setDownloadLimit(downloadLimit - 1)
  }

  const limitReached = useMemo(() => {
    return isTrial && downloadLimit === 0
  }, [downloadLimit])

  return {
    limitReached,
    downloadsLeft: downloadLimit,
    onDecrementDownloads,
  }
}
